import { NavigationElement } from "@/lib/api";

export function hasActiveChildPage(
  pages: NavigationElement[],
  activePageId: string | undefined,
) {
  return pages?.some((page) => page.page_id === activePageId);
}

type ParentChildrenMap = {
  [key: string]: NavigationElement[];
};

const createParentChildrenData = (navigationElements: NavigationElement[]) => {
  const parentsChildrenMap: ParentChildrenMap = {};
  const parents: NavigationElement[] = [];

  for (const navigationElement of navigationElements) {
    const { parent_id } = navigationElement;

    if (!parent_id) {
      parents.push(navigationElement);
    } else {
      if (!parentsChildrenMap[parent_id]) {
        parentsChildrenMap[parent_id] = [];
      }

      parentsChildrenMap[parent_id].push(navigationElement);
    }
  }

  return {
    parents,
    parentsChildrenMap,
  };
};

export function transformToParentChildrenTreeData(navigationElement: NavigationElement[]) {
  const { parents, parentsChildrenMap } = createParentChildrenData(navigationElement);

  return parents.map((node) => {
    const children = parentsChildrenMap[node.id] ?? [];

    return {
      ...node,
      children,
    };
  });
}
